import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import omit from '@babel/runtime/helpers/objectWithoutProperties';
import emptyWebGif from 'empty-web-gif';
import { func } from 'prop-types';
import { FocusedImage } from 'quintype-js';
import React from 'react';
import { USED_PARAMS, hashString } from './image-utils';
export function responsiveProps(props) {
  var image = new FocusedImage(props.slug, props.metadata);
  var _props$priority = props.priority,
      priority = _props$priority === void 0 ? false : _props$priority;

  function generatePath(size) {
    return '//' + props.imageCDN + '/' + image.path(props.aspectRatio, Object.assign({
      w: size
    }, props.imgParams));
  }

  var imageProps = {
    src: generatePath(props.defaultWidth),
    srcSet: props.widths ? props.widths.map(function (size) {
      return "".concat(generatePath(size), " ").concat(size, "w");
    }).join(',') : undefined,
    key: hashString(props.slug),
    sizes: props === null || props === void 0 ? void 0 : props.sizes
  };

  if (priority) {
    return _objectSpread(_objectSpread({}, imageProps), {}, {
      fetchPriority: 'high'
    });
  }

  return _objectSpread({}, imageProps);
}
export var ThumborImage = /*#__PURE__*/function (_React$Component) {
  _inherits(ThumborImage, _React$Component);

  var _super = /*#__PURE__*/_createSuper(ThumborImage);

  function ThumborImage(props, context) {
    var _this;

    _classCallCheck(this, ThumborImage);

    _this = _super.call(this, props, context);
    _this.state = {
      showImage: !_this.shouldLazyLoad()
    };
    return _this;
  }

  _createClass(ThumborImage, [{
    key: "shouldLazyLoad",
    value: function shouldLazyLoad() {
      if (this.props.eager === true) {
        return false;
      }

      if (this.context.lazyLoadEagerPredicate && this.context.lazyLoadEagerPredicate(this.props.eager)) {
        return false;
      }

      if (this.context.lazyLoadObserveImage && this.context.lazyLoadUnobserveImage) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var imageProps = this.state.showImage ? responsiveProps(this.props) : {
        src: emptyWebGif
      };
      return /*#__PURE__*/React.createElement(this.props.reactTag || 'img', Object.assign(imageProps, omit(this.props, USED_PARAMS), {
        ref: function ref(dom) {
          return _this2.dom = dom;
        },
        className: this.props.className ? "qt-image ".concat(this.props.className) : 'qt-image'
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.shouldLazyLoad() && this.context.lazyLoadObserveImage(this.dom, this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.shouldLazyLoad() && this.context.lazyLoadUnobserveImage(this.dom, this);
    }
  }, {
    key: "showImage",
    value: function showImage() {
      this.setState({
        showImage: true
      });
    }
  }]);

  return ThumborImage;
}(React.Component);
ThumborImage.contextTypes = {
  lazyLoadObserveImage: func,
  lazyLoadUnobserveImage: func,
  lazyLoadEagerPredicate: func
};